import React from 'react'
import styled, { withTheme } from 'styled-components'
import { CheckIcon, H5 } from '@compeon-os/components'
import { isEmpty } from 'ramda'

import {
  unternehmerGroß,
  unternehmerKlein,
  gründerGroß,
  gründerKlein,
  schnellkredit2020
} from 'helpers/productConditions'

const Container = styled.div`
  background: ${props => props.theme.infoColorLighter};
  padding: 20px;
  margin-bottom: 13px;
  border-radius: 20px;
`

const Products = styled.div`
  display: flex;
  flex-direction: column;
`

const ProductItem = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`

const StyledCheckIcon = styled(CheckIcon)`
  margin-right: 15px;
  min-width: 15px;
`

const PRODUCTS = {
  [unternehmerGroß]: 'KfW-Unternehmerkredit 037 (große Unternehmen)',
  [unternehmerKlein]: 'KfW-Unternehmerkredit 047 (KMU)',
  [gründerGroß]: 'ERP-Gründerkredit – Universell (große Unternehmen) 073, 075 mit Haftungsfreistellung',
  [gründerKlein]: 'ERP-Gründerkredit – Universell (KMU) 074, 076 mit Haftungsfreistellung',
  [schnellkredit2020]: 'KfW Schnellkredit 078 (100% Haftungsfreistellung der Bank)'
}

const PotentialProducts = ({ products, theme }) => {
  if (isEmpty(products)) return null

  return (
    <Container>
      <H5>Folgende Produkte kommen für Sie aufgrund Ihrer bisherigen Angaben potenziell infrage:</H5>
      <Products>
        {products.map(product =>
          <ProductItem key={product}>
            <StyledCheckIcon color={theme.primaryColor} size={15} />
            {PRODUCTS[product]}
          </ProductItem>
        )}
      </Products>
    </Container>
  )
}

export default withTheme(PotentialProducts)
